module.exports = __webpack_public_path__ + "static/media/patriots.03cf39bc.png";